import React, {useEffect} from 'react';
import {StyleSheet, View} from 'react-native';
import {useQueryClient} from '@tanstack/react-query';
import {observer} from 'mobx-react-lite';

import {AppRoute} from '../models/AppRoute';
import {RouteNavigatorScreenProps} from '../models/navigationTypes';
import {useNavigate} from '../navigation/util';
import {PAYMENT_CARD_QUERY_KEY} from '../queries/paymentCard';
import {useStores} from '../stores/use-stores';

const IFrameFullScreen3DS = observer(
  ({route}: RouteNavigatorScreenProps<AppRoute.THREEDS_IFRAME_FULLSCREEN>) => {
    const {cartStore, userStore} = useStores();
    const queryClient = useQueryClient();
    const isLoggedIn = userStore.isLoggedIn;
    const url = route.params.url;
    const navigationTarget = route.params.navigationTarget;

    const navigate = useNavigate();

    useEffect(() => {
      window.addEventListener('message', handleChallengeResponse, false);
      return () => window.removeEventListener('message', handleChallengeResponse);
    });

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const handleChallengeResponse = (e: any) => {
      const key = e.message ? 'message' : 'data';
      const data = e[key];

      if (data.type === '3ds-challenge') {
        if (data.outcome === 'success') {
          if (isLoggedIn) {
            queryClient.invalidateQueries({queryKey: PAYMENT_CARD_QUERY_KEY});
          }
          navigate(navigationTarget);
        } else if (data.outcome === 'complete') {
          navigate(navigationTarget);
        }
      }

      if (data.type === '3ds-checkout-challenge') {
        cartStore.setOrderPayment3DSChallenged(false);
        navigate(navigationTarget);
      }

      e.preventDefault();
      return false;
    };

    return (
      <View style={styles.main}>
        <iframe src={url} style={styles.iframe} name={`${Date.now()}`} />
      </View>
    );
  },
);

export default IFrameFullScreen3DS;

const styles = StyleSheet.create({
  main: {
    flex: 1,
    marginHorizontal: 0,
    marginVertical: 0,
    paddingBottom: 16,
    backgroundColor: 'white',
    borderWidth: 1,

    justifyContent: 'center',
    alignItems: 'stretch',
  },
  iframe: {
    flex: 1,
    marginVertical: 16,
    marginHorizontal: 16,
    borderWidth: 0,
  },
  activityIndicator: {
    position: 'absolute',
  },
});
